import * as React from 'react';
import { FavouriteDefinition } from 'app/types-shared';
import { FiltersDrawer } from 'app/area/filters/filters-drawer';
import { CreateReport } from '../../saved-reports';
import styles from './favourite.scss';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ReactNode, useEffect } from 'react';

interface FavouriteLayoutContainerProps {
  definition: FavouriteDefinition;
  translation: any;
  isCreateReportOpen: boolean;
  updateExistingReport: boolean;
  initiallyOpenFilter: boolean;
  closeReportCreator: () => void;
  updateDefinition: (transform?: (definition: FavouriteDefinition) => FavouriteDefinition) => void;
  searchRequiredUsers: boolean;
  hideFilters: boolean;
  getSearchRequiredUsers: () => void;
  children: ReactNode;
}

export function FavouriteLayout({
  getSearchRequiredUsers,
  definition, translation, children, updateDefinition,
  closeReportCreator, isCreateReportOpen, updateExistingReport, 
  initiallyOpenFilter, searchRequiredUsers, hideFilters
}: FavouriteLayoutContainerProps) {

  useEffect(() => {
    getSearchRequiredUsers?.();
  }, []);

  return <MainGridContainer className={styles.searchResults}>
    {isCreateReportOpen && <CreateReport
      closeReportCreator={closeReportCreator}
      definition={definition}
      searchRequiredUsers={searchRequiredUsers}
      updateReport={updateExistingReport}
    />}
    {hideFilters ? children : <div className={styles.drawerWithBar}>
      <FiltersDrawer
        title={translation.filters_title}
        updateDefinition={updateDefinition}
        definition={definition}
        initiallyOpen={initiallyOpenFilter}>
        {children}
      </FiltersDrawer>
    </div>}
  </MainGridContainer>;
}
